import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerDataService } from "./services/customer-data.service";
import { faFileShield, faHourglassEnd, faLandmark, faPowerOff, faShopLock } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from './services/auth.service';
import { RestService } from './services/rest.service';
import { FirebaseService } from './services/firebase.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title: any;
  isLoggedIn: any;
  faLandmark = faLandmark;
  faPowerOffIcon = faPowerOff;
  faFileShieldIcon = faFileShield;
  faHourglassEndIcon = faHourglassEnd;
  faShopLogoIcon = faShopLock;

  constructor(public cdService: CustomerDataService,
    private authService: AuthService,
    private router: Router,
    private restService: RestService,
    private firebaseService: FirebaseService) { }

  ngOnInit(): void {
    this.cdService.isTabActive$.next(true);

    document.addEventListener('visibilitychange', (e) => {
      //console.log('on onVisibilityChange', e);
      if (document.visibilityState === 'visible') {
        this.cdService.isTabActive$.next(true);
      } else {
        this.cdService.isTabActive$.next(false);

      }
    }
    );
    this.authService.checkAuth().subscribe(
      {
        next: (data) => {
          const currentUrl = this.router.url;
          this.authService.login(data.fbToken);
          this.cdService.role$.next(data.role);
          this.cdService.userId$.next(data.uid);

          const isLoginRoute = !!currentUrl.match(/login/gi);
          if (isLoginRoute) {
            this.router.navigate(['/customers'])
          }
        },
        error: (error) => {
          this.cdService.role$.next('')
          this.cdService.userId$.next('');
          this.authService.clearLogin()
          console.log(error)
          this.router.navigate(['/login']);

        }
      }
    )
    this.authService.isLoggedIn.subscribe((isLoggedIn) => {
      this.isLoggedIn = isLoggedIn;
      if (isLoggedIn) {
        this.firebaseService.getCompanies().subscribe((data: any) => {
          // console.log(data)
          this.cdService.setCompanies(data);
        });
      }

    }); // {2}

    //console.log(this.isLoggedIn)
    // this.data.autoLogin();

  }


  logout() {
    this.restService.postMethod(this.restService.urls.logout, {}).subscribe(
      {
        next: () => {
          this.authService.logout()
        },
        error: (error: any) => {
          console.log(error, 'login error')

        }
      }
    )
    // window.location.href = this.restService.urls.logout;
    /* this.cdService.logout().subscribe((res: any) => {
      // console.log(res)
      this.cdService.logingout()
 
    }) */

  }



}

